<ng-container *ngIf="authenticate">
  <div class="env-banner" [attr.data-mode]="envText" *ngIf="envText"></div>

  <rft-sidebar></rft-sidebar>
</ng-container>

<section class="outlet">
  <router-outlet></router-outlet>
</section>
